<div id="profile" class="profile-outer" data-testid="profile-container" [ngClass]="{'dropdown-visible': dropdownVisible}" (click)="profileClick()">
  @if (!isAuthorized()) {
    <div class="profile-container unauthorized">
      <img class="user-icon-default" [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/user_icon.svg'" />
      <img class="profile-hamburger-icon" [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/profile_hamburger.svg'" />
    </div>
  }
  @if (isAuthorized()) {
    <div class="profile-container authorized">
      <h6 class="username()" [ngClass]="{'small-padding': subscriptionType()?.includes('pro.'), 'medium-padding': subscriptionType()?.includes('proplus.') }">{{ username() }}</h6>
      @if (subscriptionType()?.includes('pro.')) {
        <img id="pro-badge" src="assets/icons/default/ui/PRO_icon.svg"/>
      }
      @if (!avatarLink()) {
        <img class="user-icon-default"
          [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/user_icon.svg'" />
      }
      @if (avatarLink()) {
        <img class="user-icon"
          [src]="avatarLink()" />
      }
      @if (subscriptionType()?.includes('proplus.')) {
        <img id="proplus-badge" src="assets/icons/default/ui/PROPLUS_icon.svg"/>
      }
      <img class="profile-hamburger-icon" [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/profile_hamburger.svg'" />
    </div>
  }
</div>
